module.exports = __webpack_public_path__ + "0f44291a77dc9d61a5e085edb9f89698.svg";